/* eslint-disable react-hooks/exhaustive-deps */
import NiceModal from "@ebay/nice-modal-react";
import { Radio, RadioGroup } from "@mui/material";
import { adminRequester } from "App";
import AdminImage from "components/Image/AdminImage";
import P from "components/P";
import AdminCustomButton, {
  style as buttonStyle,
} from "components/buttons/AdminCustomButton";
import CustomButton from "components/buttons/CustomButton";
import DateChoice2 from "components/inputs/datePicker/dateChoice/DateChoice2";
import FlexChild from "layouts/flex/FlexChild";
import FlexGrid from "layouts/flex/FlexGrid";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./OrderInquirySearch.module.css";
import { toast } from "react-toastify";
import _ from "lodash";

const StatisticInquirySearch = forwardRef((props, ref) => {
  const [user, setUser] = useState();
  const { reset, setReset, research } = props;

  // const { isMobile } = useContext(BrowserDetectContext);
  const [operation, setOperation] = useState("in");
  const [reload, setReload] = useState(false);
  const [isMounted, setMounted] = useState(false);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const startInit = new Date();
  startInit.setHours(0, 0, 0, 0);
  startInit.setDate(1);
  const endInit = new Date();
  endInit.setHours(23, 59, 59, 999);

  const [startDate, setStartDate] = useState(startInit);
  const [endDate, setsEndDate] = useState(endInit);

  const { t } = useTranslation();

  const dateRef = useRef();

  //   const koreaTimeDiff = 9 * 60; // 한국은 UTC+9

  const maxDate = new Date();

  maxDate.setFullYear(maxDate.getFullYear() + 10);
  const selectCategory = () => {
    NiceModal.show("categoryRegister", {
      editable: false,
      onChange: ({ value }) =>
        setCategories([...new Set([...categories, value])]),
    });
  };
  const showSelected = () => {
    if (products?.length == 0) {
      toast.error("선택된 상품이 없습니다.", {
        autoClose: 1000,
        position: "bottom-center",
      });
      return;
    }
    NiceModal.show("show", {
      title: "선택된 상품",
      list: products,
      children: ({ list, setList }) => (
        <div style={{ padding: 20 }}>
          <VerticalFlex justifyContent="flex-start" gap={10} flexStart>
            {list?.length > 0 &&
              list
                ?.sort((p1, p2) => p1?.title?.localeCompare(p2?.title))
                ?.map((product, index) => (
                  <FlexChild key={product.id}>
                    <HorizontalFlex gap={10} alginItems="flex-start">
                      <FlexChild width="max-content">
                        <P width="50px">{index + 1}</P>
                      </FlexChild>
                      <FlexChild width="max-content">
                        <AdminImage
                          src={product.thumbnail}
                          width="100px"
                          height="100px"
                        />
                      </FlexChild>
                      <FlexChild>
                        <P>{product.title}</P>
                      </FlexChild>
                      <FlexChild width="max-content">
                        <AdminCustomButton
                          text={"X"}
                          style={{ hover: { color: "red" } }}
                          onClick={() =>
                            setList([
                              ...new Set(
                                list.filter((p) => p.id !== product.id)
                              ),
                            ])
                          }
                        />
                      </FlexChild>
                    </HorizontalFlex>
                  </FlexChild>
                ))}
          </VerticalFlex>
        </div>
      ),
      onChange: ({ list }) => setProducts([...list]),
    });
  };
  const selectProduct = () => {
    const extraCondition = { expand: "variants" };
    if (user && user?.role !== "admin")
      extraCondition.store_id = user?.store_id;
    NiceModal.show("adminCheckSelect", {
      editable: false,
      title: "상품 선택",
      // list: productList,
      request: (...props) => adminRequester.getProducts(...props),
      code: "products",
      extraCondition: extraCondition,
      Search: ({ callback }) => (
        <input
          type="text"
          onKeyDown={(e) => {
            if (e.key === "Enter") callback({ t: e.target.value });
          }}
          style={{
            outline: "none",
            backgroundColor: "rgb(233, 233, 233)",
            borderRadius: "10px",
            marginLeft: "auto",
            paddingRight: "10px",
            paddingLeft: "10px",
            minWidth: "250px",
          }}
          placeholder="search..."
        />
      ),
      justifyContent: "flex-start",
      headers: [
        {
          width: 100,
          label: "id",
          code: "id",
        },
        {
          label: "이름",
          Cell: ({ row }) => (
            <FlexChild>
              <HorizontalFlex
                justifyContent="flex-start"
                gap={10}
                alignItems="flex-start"
              >
                <FlexChild width="max-content">
                  <AdminImage src={row.thumbnail} width={100} height={100} />
                </FlexChild>
                <FlexChild width="max-content" alignItems="flex-start">
                  <P size={18}>{row.title}</P>
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
          ),
        },
      ],
      onSelect: (items) =>
        setProducts([..._.uniqBy([...products, ...items], "id")]),
    });
  };
  const onSearchClick = () => {
    let data = {};
    let startDateStr = dateRef.current.getStartDate().getTime();
    let endDateStr = dateRef.current.getEndDate().getTime();
    data.start_date = startDateStr;
    data.end_date = endDateStr;
    // data.status = "product";
    if (products?.length > 0)
      data.products = products?.map((product) => product.id);
    if (categories?.length > 0)
      data.categories = categories?.map((category) => category.id);
    data.method = operation;
    if (user && user?.role !== "admin") data.store_id = user?.store_id;
    props.callback && props.callback(data);
  };
  const onInitializationClick = () => {
    setOperation("in");
    setCategories([]);
    setStartDate(startInit);
    setsEndDate(endInit);
    dateRef.current.setActive([false, false, false, false, false]);
    setProducts([]);
    setReload(true);
  };
  useEffect(() => {
    if (reload) {
      setReload(false);
      const interval = setInterval(() => {
        onSearchClick();
        clearInterval(interval);
      }, 100);
    }
  }, [reload]);

  const searchStyle = {
    backgroundColor: "var(--admin-main-color)",
    padding: "7px 20px",
    border: "1px solid #ddd",
  };

  const initializationStyle = {
    backgroundColor: "white",
    padding: "7px 20px",
    color: "black",
    border: "1px solid #ddd",
  };

  useEffect(() => {
    setMounted(true);
    adminRequester.getCurrentUser(({ user }) => setUser(user));
  }, []);
  useEffect(() => {
    if (isMounted && user) {
      onInitializationClick();
    }
  }, [isMounted, user]);
  useEffect(() => {
    if (reset) {
      onInitializationClick();
      setReset(false);
    }
  }, [reset]);
  useEffect(() => {
    if (research) onSearchClick();
  }, [research]);
  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <HorizontalFlex gap={10}>
            <FlexChild
              width={"10%"}
              backgroundColor={"var(--admin-table-bg-color)"}
            >
              <div className={style.titleWrap}>
                <Center>
                  <P size={15} weight={"bold"}>
                    기간
                  </P>
                </Center>
              </div>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex gap={10}>
                <FlexChild width={"max-content"}>
                  {/* <TestDatePicker ref={dateRef} startDate={startDate} endDate={endDate} maxDate={maxDate} /> */}
                  <DateChoice2
                    ref={dateRef}
                    startDate={startDate}
                    endDate={endDate}
                    maxDate={maxDate}
                  />
                </FlexChild>
                <FlexChild />
              </HorizontalFlex>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent={"flex-start"}>
            <FlexChild
              width={"10%"}
              backgroundColor={"var(--admin-table-bg-color)"}
            >
              <div className={style.titleWrap}>
                <Center>
                  <P size={15} weight={"bold"}>
                    카테고리
                  </P>
                </Center>
              </div>
            </FlexChild>

            <HorizontalFlex justifyContent="flex-start" gap={10}>
              {categories?.length > 0 &&
                categories?.map((category) => (
                  <FlexChild key={category.id} width={"max-content"}>
                    <AdminCustomButton
                      text={category.name}
                      style={{ hover: { color: "red" } }}
                      onClick={() =>
                        setCategories([
                          ...new Set(
                            categories.filter((c) => c.id !== category.id)
                          ),
                        ])
                      }
                    />
                  </FlexChild>
                ))}
              <FlexChild width={"max-content"}>
                <AdminCustomButton
                  text="카테고리 선택 추가"
                  style={buttonStyle.blue}
                  onClick={selectCategory}
                />
              </FlexChild>
            </HorizontalFlex>
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <HorizontalFlex gap={10}>
            <FlexChild
              width={"10%"}
              backgroundColor={"var(--admin-table-bg-color)"}
            >
              <div className={style.titleWrap}>
                <Center>
                  <P size={15} weight={"bold"}>
                    검색 방식
                  </P>
                </Center>
              </div>
            </FlexChild>
            <FlexChild>
              <RadioGroup
                value={operation}
                onChange={(e) => setOperation(e.target.value)}
              >
                <HorizontalFlex gap={10} justifyContent={"flex-start"}>
                  <FlexChild width={"max-content"}>
                    <Radio name="productType" value="in" />
                    <P size={15} color={"#aaa"}>
                      해당 상품만 포함
                    </P>
                  </FlexChild>
                  <FlexChild width={"max-content"}>
                    <Radio name="productType" value="notin" />
                    <P size={15} color={"#aaa"}>
                      해당 상품만 제외
                    </P>
                  </FlexChild>
                </HorizontalFlex>
              </RadioGroup>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>

        <HorizontalFlex gap={10} justifyContent={"flex-start"}>
          <FlexChild
            width={"10%"}
            backgroundColor={"var(--admin-table-bg-color)"}
          >
            <div className={style.titleWrap}>
              <Center>
                <P size={15} weight={"bold"}>
                  상품 조건
                </P>
              </Center>
            </div>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex gap={10} justifyContent="flex-start">
              <FlexChild width="max-content">
                <AdminCustomButton
                  text={products?.length === 0 ? "전체 선택됨" : "전체 선택"}
                  onClick={() => setProducts([])}
                  selected={products?.length === 0}
                />
              </FlexChild>

              {products?.length > 0 && (
                <FlexChild width="max-content">
                  <AdminCustomButton
                    text={`${products?.length}개의 상품 선택됨`}
                    onClick={showSelected}
                    selected={products?.length > 0}
                  />
                </FlexChild>
              )}
              <FlexChild width="max-content">
                <AdminCustomButton
                  text="상품 선택 추가"
                  style={buttonStyle.blue}
                  onClick={selectProduct}
                />
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
        </HorizontalFlex>
        <FlexChild backgroundColor={"#f5f6fb"} padding={"15px 0"}>
          <HorizontalFlex gap={20}>
            <FlexChild justifyContent={"flex-end"}>
              <CustomButton
                text={"조건검색"}
                style={searchStyle}
                onClick={onSearchClick}
              />
            </FlexChild>
            <FlexChild>
              <CustomButton
                text={"초기화"}
                style={initializationStyle}
                onClick={() => setReset(true)}
              />
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
});

export default StatisticInquirySearch;
